var _linearGradient, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgGoogleArcore = function SvgGoogleArcore(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: ".9 .8 339.7 392.4",
    width: 2163,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "80.258%",
    x2: "21.439%",
    y1: "98.614%",
    y2: "-10.489%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a237e",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a237e",
    stopOpacity: 0.3
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m174.3 121.2c-28.1 0-52.5 15.3-65.7 37.9l51.7 29.8c8.7 5 19.3 5 28 0l51.6-29.8c-13-22.7-37.5-37.9-65.6-37.9z",
    fill: "#e1bee7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.3 188.9-51.7-29.8c-6.5 11.2-10.2 24.1-10.2 37.9 0 41.9 33.9 75.8 75.8 75.8s75.8-33.9 75.8-75.8c0-13.8-3.7-26.8-10.2-37.9l-51.6 29.8c-8.5 5-19.2 5-27.9 0z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.6 289.6-94.6-54.7c-13.1 22.7-37.6 37.9-65.7 37.9v120.3c4.5 0 8.9-1.2 12.9-3.5l147.5-85.2s.1 0 .1-.1c5.7-3.2 5.5-11.5-.2-14.7z",
    fill: "#7b1fa2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.3 272.8c-28.1 0-52.6-15.2-65.7-37.9l-104.2 60.2c2.2 3.9 5.5 7.1 9.4 9.4l147.5 85.2c4 2.3 8.4 3.5 12.9 3.5v-120.4z",
    fill: "#4a148c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.3 121.2v-120.3c-4.5 0-8.9 1.2-12.9 3.5l-147.5 85.2c-4 2.3-7.2 5.6-9.4 9.4l104.2 60.2c13.1-22.8 37.6-38 65.6-38z",
    fill: "#7b1fa2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.8 89.6s-.1 0-.1-.1l-147.5-85.2c-4-2.3-8.4-3.5-12.9-3.5v120.3c28.1 0 52.6 15.2 65.7 37.9l94.6-54.6c5.7-3.2 5.9-11.5.2-14.8z",
    fill: "#4a148c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.5 197c0-13.8 3.7-26.8 10.1-37.9l-104.2-60.2c-2.2 3.9-3.5 8.3-3.5 12.9v170.3c0 4.6 1.2 9 3.5 12.9l104.2-60.2c-6.4-11-10.1-24-10.1-37.8z",
    fill: "#ba68c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 234.9c-13.1 22.7-37.6 37.9-65.6 37.9-11.2 0-21.9-2.5-31.5-6.8l129.3 74.7 62.6-36.1c5.8-3.3 5.8-11.7 0-15z",
    fill: "url(#a)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleArcore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-arcore.4ebebee5.svg";
export { ForwardRef as ReactComponent };